/**
 * Usage:
 *
 * data-sw-shapejs-user-orientation=<creatorId>
 *
 */

var $ = require('js/sw-jquery/sw-jquery');

var MODEL_FILE_ID_SELECTOR = '[data-sw-user-orientation-modelFileId-input]';
var ROTATION_TYPE_ID_SELECTOR = '[data-sw-user-orientation-rotation-type-id-input]';

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-shapejs-user-orientation-form]').each(function() {
    var $el = $(this);

    require([
      'js/lib/models/ModelManager',
      'js/lib/views/UserOrientationParamForm'
    ], function(ModelManager, UserOrientationParamForm) {

      var creatorId = $el.data('swShapejsUserOrientationForm');
      var shapeJsModel = ModelManager.getShapeJs(creatorId);
      var modelFileId = $el.find(MODEL_FILE_ID_SELECTOR).val();
      var rotationTypeId = $el.find(ROTATION_TYPE_ID_SELECTOR).val();

      new UserOrientationParamForm({
        stateId: creatorId,
        el: $el,
        model: shapeJsModel,
        modelFileId: modelFileId,
        rotationTypeId: parseInt(rotationTypeId, 10)
      });

    });

  });

};
